import { useMinimalsTheme } from '@tom-ui/ui'
import { useId } from 'react'

export const RailTrackPattern = () => {
  const theme = useMinimalsTheme()
  const uid = useId().replace(/:/g, '')

  const railColor = theme.palette.grey[700]
  const sleeperColor = theme.palette.grey[500]

  // Centered narrow track — rails close together, sleepers extending slightly beyond
  const trackHeight = 50
  const center = trackHeight / 2
  const railGap = 6 // distance between the two rails
  const rail1Y = center - railGap / 2 - 1 // ~22
  const rail2Y = center + railGap / 2 // ~28
  const railHeight = 2
  const sleeperSpacing = 14
  const sleeperWidth = 4
  const sleeperOverhang = 4 // how far sleepers extend beyond rails
  const sleeperY = rail1Y - sleeperOverhang
  const sleeperHeight = rail2Y - rail1Y + railHeight + sleeperOverhang * 2

  return (
    <svg width='100%' height='100%' xmlns='http://www.w3.org/2000/svg'>
      <defs>
        <pattern
          id={`rtp-${uid}`}
          x='0'
          y='0'
          width={sleeperSpacing}
          height={trackHeight}
          patternUnits='userSpaceOnUse'
        >
          <rect
            x={(sleeperSpacing - sleeperWidth) / 2}
            y={sleeperY}
            width={sleeperWidth}
            height={sleeperHeight}
            fill={sleeperColor}
            rx='1'
          />
        </pattern>
      </defs>

      {/* Sleepers */}
      <rect width='100%' height='100%' fill={`url(#rtp-${uid})`} />

      {/* Rails */}
      <rect x='0' y={rail1Y} width='100%' height={railHeight} fill={railColor} />
      <rect x='0' y={rail2Y} width='100%' height={railHeight} fill={railColor} />
    </svg>
  )
}
